import { useSubscribe } from "@src/hooks/useSubscribe";
import { selectUnreadMessages } from "@src/selectors/chat";
import { selectActivePoll } from "@src/selectors/poll";
export const useUnreadMessagesCount = () => {
    const chatUnReadMessages = useSubscribe(selectUnreadMessages());
    const activePoll = useSubscribe(selectActivePoll());
    return chatUnReadMessages.length + (activePoll ? 1 : 0);
};
